export enum TableName {
  GlobalConfiguration = "config",
  Variables = "vars",
  RailRoaders = "railroaders",
  Stations = "stations",
  RailRuns = "railruns",
  Trains = "trains",
  Upgrades = "upgrades",
}
